import { ButtonGroup } from '@mui/material';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { movementReasonService, movementService } from 'services/api';
import { useEffect, useState } from 'react';
import { IOption } from 'interfaces';
import { loadingActions } from 'features';
import { useAppDispatch } from 'app/store';
import { UninvoicedMovementsColumns } from 'components/common/enhanced/common-headers';

export const UninvoicedMovements = () => {
  const translationPrefix = 'pages.movements.uninvoiced';
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [movementReasons, setMovementReasons] = useState<IOption[]>([]);

  useEffect(() => {
    dispatch(loadingActions.startLoading());
    movementReasonService.getAllPaginated().then((res) => {
      setMovementReasons(res.results);
    });
    dispatch(loadingActions.stopLoading());
  }, []);

  const columns: GridColDef[] = UninvoicedMovementsColumns(
    movementReasons.map((reason) => reason.code)
  );

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <div>
          <ButtonGroup size="small"></ButtonGroup>
        </div>
      }>
      <EnhancedDataGrid
        columns={columns}
        service={movementService}
        outerParams={{ ddt_closed: 'false', billable: 'true', invoice: 'false' }}
      />
    </TenantPage>
  );
};

export default UninvoicedMovements;
